function getBeachChairType(model?: string | null) {
  switch (model) {
    case '2_SEAT_RECLINER':
      return '2 Sitzer-Liegekorb'
    case '2.5_SEAT_RECLINER':
      return '2 1/2 Sitzer-Liegekorb'
    case 'BALTIC_BEACH_CHAIR':
      return 'Ostseestrandkorb'
    case '2_SEAT_CHAIR':
      return '2er Korb'
    case '3_SEAT_CHAIR':
      return '3er Korb'
    case 'FULL_RECLINER':
      return 'Ganzlieger'
    case 'BEACH_CHAIR_BED':
      return 'Schlafstrandkorb'
    case 'DAYBED':
      return 'Daybed'
    case 'XL_BEACH_CHAIR':
      return 'XL Strandkorb'
    case 'SAUNA':
      return 'Saunakorb'
    case 'FAMILY_BEACH_CHAIR':
      return 'Familienstrandkorb'
    case 'XL_BEACH_CHAIR_TURNABLE':
      return 'XL-Strandkorb mit Drehteller'
    case '2_SEAT_CHAIR_TURNABLE':
      return '2-Sitzer mit Drehteller'
    case 'COMFORT':
      return 'Komfortstrandkorb'
    case 'WHEELCHAIR':
      return 'Barrierefreier Strandkorb'
    case 'CHILDBEACHCHAIR':
      return 'Kinder Strandkorb'
    case 'XXL_BEACH_CHAIR':
      return 'XXL Strandkorb'
    case 'DOG_BEACH_CHAIR':
      return 'Hundestrandkorb'
    case 'FKK_BUDJE':
      return 'FKK Budje'
    case 'NORDORT':
      return 'Nordort'
    case 'PREMIUM':
      return 'Premiumliege'
    case 'RETRO':
      return 'Retrokorb'
    case undefined:
    case null:
    default:
      return 'Keine Angabe'
  }
}

export function useBeachChairModel() {
  return {
    getBeachChairType,
  }
}
